import * as React from 'react';
const WriteBoardIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_974_27620"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={25}
      height={24}
    >
      <rect x={0.00585938} width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_974_27620)">
      <path
        d="M13.8327 20.5961V19.2346C13.8327 19.1141 13.8545 18.9993 13.8981 18.8904C13.9417 18.7814 14.0103 18.6801 14.1039 18.5865L19.2616 13.4538C19.3859 13.3359 19.5205 13.25 19.6654 13.1961C19.8103 13.1423 19.9552 13.1154 20.1 13.1154C20.2552 13.1154 20.4068 13.1449 20.5548 13.2038C20.7029 13.2628 20.8359 13.3513 20.9539 13.4692L21.8789 14.4038C21.9865 14.5282 22.0699 14.6628 22.1289 14.8077C22.1878 14.9525 22.2173 15.0974 22.2173 15.2423C22.2173 15.3871 22.1904 15.5346 22.1366 15.6846C22.0827 15.8346 21.9968 15.9718 21.8789 16.0961L16.7462 21.2288C16.6526 21.3224 16.5513 21.391 16.4423 21.4346C16.3334 21.4782 16.2186 21.5 16.0981 21.5H14.7366C14.4789 21.5 14.2638 21.4137 14.0914 21.2413C13.919 21.0688 13.8327 20.8538 13.8327 20.5961ZM15.025 20.3077H15.975L19.2212 17.0461L18.7712 16.5615L18.2962 16.1019L15.025 19.3577V20.3077ZM6.31356 21.5C5.80843 21.5 5.38086 21.325 5.03086 20.975C4.68086 20.625 4.50586 20.1974 4.50586 19.6923V4.3077C4.50586 3.80257 4.68086 3.375 5.03086 3.025C5.38086 2.675 5.80843 2.5 6.31356 2.5H13.5078C13.7488 2.5 13.9805 2.5468 14.203 2.6404C14.4254 2.73398 14.6187 2.86283 14.7828 3.02693L18.9789 7.22303C19.143 7.38714 19.2718 7.58042 19.3654 7.80285C19.459 8.02528 19.5058 8.25701 19.5058 8.49803V10.548H18.0058V8.49995H14.4097C14.152 8.49995 13.937 8.41373 13.7645 8.24128C13.5921 8.06884 13.5059 7.85378 13.5059 7.5961V3.99998H6.31356C6.23663 3.99998 6.1661 4.03203 6.10198 4.09613C6.03788 4.16024 6.00583 4.23077 6.00583 4.3077V19.6923C6.00583 19.7692 6.03788 19.8397 6.10198 19.9038C6.1661 19.9679 6.23663 20 6.31356 20H11.6404V21.5H6.31356ZM18.7712 16.5615L18.2962 16.1019L19.2212 17.0461L18.7712 16.5615Z"
        fill="#333333"
      />
    </g>
  </svg>
);
export default WriteBoardIcon;
